import { useCallback, useRef, useState } from 'react';
import { Container } from 'react-bootstrap';
import Recaptcha from "react-google-recaptcha";
import CardAlert from '../components/CardAlert';
import NavBar from '../components/Navbar';

import { authenticate } from '../services/api';

function Auth({ setToken, modulo }) {

    const [password, setPassword] = useState('');
    const [disabledSubmit, setDisableButton] = useState(true)
    const [error, setError] = useState(false);
    const captchaRef = useRef(null)

    const handlerSubmit = async e => {

        setError(null);
        e.preventDefault();

        if (password === "" || password === null) {
            return false;
        }

        return authenticate(modulo, password)
            .then(result => {
                setToken(result.data.token);
            })
            .catch(err => {
                console.log(err);
                setError('Usuário/senha inválidos.');
            });

    }

    let subsubtitle = "GPR Eleições 2026";

    if (modulo === "GPRF") {
        subsubtitle = "GPR Forças 2026";
    }

    return (
        <>
            <NavBar title="Dados Eleitorais" subtitle="" subsubtitle={subsubtitle} modulo={modulo} />
            <Container style={{ marginTop: 200 }} className="text-center" >
                <form onSubmit={handlerSubmit}>
                    <div className="mb-3">
                        <label>Senha de Acesso:</label>
                        <input
                            type="password"
                            className="form-control"
                            placeholder="****"
                            onChange={e => setPassword(e.target.value)}
                            style={{ width: "30%", margin: "auto" }}
                        />
                    </div>
                    {
                        error && (
                            <CardAlert tipo="danger" close={true}>
                                A senha digitada está incorreta
                            </CardAlert>
                        )
                    }
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <Recaptcha sitekey={process.env.REACT_APP_SITE_KEY} ref={captchaRef} onChange={useCallback(() => setDisableButton(false), [])} />
                    </div>
                    <div className="d-grid text-center" style={{ marginTop: 20 }}>
                        <button type="submit" disabled={disabledSubmit} className="btn btn-primary" style={{ backgroundColor: '#587473', border: 'none' }}>
                            Entrar
                        </button>
                    </div>
                </form>
            </Container>
        </>
    );

}

export default Auth;